import ModalHeader from './ModalHeader'
import ModalContent from './ModalContent'
import ModalContentWrapper from './ModalContentWrapper'
import ModalMainWrapper from './ModalMainWrapper'
import EmbedHubSpotForm from '../EmbedHubSpotForm'

const PartnerWithUsModal = () => {
    return (
        <ModalMainWrapper>
            <ModalContentWrapper>
                <ModalHeader title="Partner With us" />
                <ModalContent>
                    <EmbedHubSpotForm
                        portalId="21994206"
                        formId="bda6f6ae-9125-4d8a-b47e-d572680889a5"
                        formName="Partner With Us"
                    />
                </ModalContent>
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}

export default PartnerWithUsModal
